'use strict';

var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();
Analytics.getInstance();

function menuHoverHandler() {
	var element = this;

	var menuTimeout = window.setTimeout(function testHover() {
		var menuLabel = element.getElementsByTagName('a')[0].text.trim();
		myAnalytics.trackEvent('Menu', 'Expand', menuLabel, undefined, true);
	}, 750);

	element.addEventListener('mouseleave', function clearMenuTimeout() {
		window.clearTimeout(menuTimeout);

		element.removeEventListener('mouseleave', clearMenuTimeout);
	});
}

function init() {
	var dropdownEls = document.querySelectorAll('.nav--desktopPrimary > .node--hasChild, .nav--secondary .node--hasChild');
	if (!dropdownEls.length)
		return;

	for (var i = 0; i < dropdownEls.length; i++) {
		dropdownEls[i].addEventListener('mouseenter', menuHoverHandler);
	}
}

module.exports = {
	init: init
}
